/**
 * The pre-launch bar.
 *
 * Rendered in `App`, directly above `SiteHeader` — not in `Landing`, which is
 * a route inside `<main>` and therefore renders *below* the header. "Above the
 * navigation" is only reachable from the layout, so that is where it lives. It
 * consequently shows on every page, which is what a launch notice wants
 * anyway.
 *
 * Two copies, long and short, swapped by media query rather than by measuring
 * the viewport in JS: no resize listener, no hydration mismatch, and the right
 * one is already correct on first paint.
 */
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import { trackEvent } from '../lib/consent';

const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61593490715076';

export default function AnnouncementBar() {
  const { t } = useTranslation();

  return (
    <div className="announce" role="region" aria-label={t('announce.label', 'Launch announcement')}>
      <p className="announce__text">
        <span className="announce__mark" aria-hidden="true">✦</span>
        <span className="announce__long">
          {t(
            'announce.long',
            'We are preparing the gateway: Gompa is officially launching soon on web and iOS.'
          )}
        </span>
        <span className="announce__short">
          {t('announce.short', 'Preparing the Gateway • Launching soon on Web & iOS')}
        </span>
      </p>
      {/* A second, quieter line rather than crowding the launch line itself —
          the announcement is still the one thing this bar leads with. */}
      <p className="announce__social">
        <a
          href={FACEBOOK_URL}
          target="_blank"
          rel="noreferrer noopener"
          onClick={() => trackEvent('cta_click', { cta_id: 'announce_facebook' })}
        >
          <Icon name="facebook" size={13} solid />
          {t('announce.followFacebook', 'Follow us on Facebook')}
        </a>
      </p>
    </div>
  );
}
